import { render } from "./VODBreadcrumb.vue?vue&type=template&id=3b77386c"
import script from "./VODBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./VODBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODBreadcrumb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b77386c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b77386c', __exports__)) {
    api.reload('3b77386c', __exports__)
  }
  
  module.hot.accept("./VODBreadcrumb.vue?vue&type=template&id=3b77386c", () => {
    api.rerender('3b77386c', render)
  })

}


export default __exports__